import angular from "angular";
import template from "./admin-campus-create-classroom.html";
import AdminSchoolsLocationsClassroomsCreateController from "./admin-campus-create-classroom.controller";
function config($stateProvider, $urlRouterProvider, USER_ROLES) {
  $stateProvider.state(
    "drivecoach.admin.schools.view.locations.view.classrooms.create",
    {
      url: "/create",
      controller: AdminSchoolsLocationsClassroomsCreateController,
      controllerAs: "vm",
      template: template,
      data: {
        authorizedRoles: [
          USER_ROLES.admin,
          USER_ROLES.administrator,
          USER_ROLES.owner,
        ],
      },
    },
  );
}
config.$inject = ["$stateProvider", "$urlRouterProvider", "USER_ROLES"];

export default angular
  .module("admin.dashboard.schools.view.locations.view.classrooms.create", [])
  .config(config)
  .controller(
    "AdminSchoolsLocationsClassroomsCreateController",
    AdminSchoolsLocationsClassroomsCreateController,
  );
